export const identity = (x) => x

export const pick = (obj, keys) => {
  const out = {}
  keys.forEach((key) => (out[key] = obj[key]))
  return out
}

export const delay = async (time) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time)
  })
}

export function toTimestamp(d) {
  return d === null || d === undefined ? d : +new Date(d + 'Z')
}

export function toDateString(d) {
  if (d === null || d === undefined) return d
  const date = new Date(toTimestamp(d))
  return date.toLocaleDateString().replace(/\d\d(\d\d)$/, '$1')
}

export function toTimeString(d) {
  if (d === null || d === undefined) return d
  const date = new Date(toTimestamp(d))
  return date.toLocaleTimeString().replace('AM', 'am').replace('PM', 'pm')
}

const dateTimeFormatOptions = {
  month: 'numeric',
  day: 'numeric',
  year: '2-digit',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
}

function formatDateTime(date, options = dateTimeFormatOptions) {
  if (!isDate(date)) return null
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

export function toViewerDateTimeString(d) {
  if (d === null || d === undefined) return d
  return formatDateTime(new Date(toTimestamp(d))) ?? d
}

export function toClipLocalDateTimeString(d) {
  if (typeof d !== 'string') return null

  const match = d.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/
  )

  if (!match) return null

  const [, year, month, day, hour, minute, offset] = match
  const localDate = new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day))
  )
  const dateString = new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    timeZone: 'UTC',
  }).format(localDate)
  const timeString = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(1970, 0, 1, Number(hour), Number(minute))))
  const timezone = offset === 'Z' ? 'UTC' : `UTC${offset}`

  return `${dateString}, ${timeString} ${timezone}`
}

export function isDate(date) {
  return date instanceof Date && !isNaN(date.valueOf())
}

export function getAge(birthdayStr) {
  const birthday = new Date(birthdayStr)
  if (!isDate(birthday)) return null
  const ageDifMs = Date.now() - birthday
  const ageDate = new Date(ageDifMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
}
